import { forwardRef } from 'react';
import { Blockquote as RadixBlockquote } from '@radix-ui/themes';
import type { RadixBlockquoteProps } from '@/types/radix-ui';

/**
 * Blockquote component - wrapper around Radix UI Blockquote
 * Provides semantic blockquotes for quoted content
 */
export type BlockquoteProps = RadixBlockquoteProps;

const Blockquote = forwardRef<HTMLQuoteElement, BlockquoteProps>(
  (props, ref) => {
    return <RadixBlockquote ref={ref} {...props} />;
  }
);

Blockquote.displayName = 'Blockquote';

export { Blockquote };
